(() => {
  if (window.ksMobileHeaderV2Initialized) return;
  window.ksMobileHeaderV2Initialized = true;

  const MOBILE_BREAKPOINT = 1024;
  let resizeFrame = null;
  let headerObserver = null;

  const searchIcon = `
    <svg aria-hidden="true" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="1.8" stroke-linecap="round">
      <circle cx="11" cy="11" r="7"></circle>
      <path d="m20 20-4.2-4.2"></path>
    </svg>`;

  const arrowIcon = `
    <svg aria-hidden="true" viewBox="0 0 24 24" fill="none"
      stroke="currentColor" stroke-width="1.9" stroke-linecap="round"
      stroke-linejoin="round">
      <path d="M5 12h14"></path>
      <path d="m14 7 5 5-5 5"></path>
    </svg>`;

  const getMobileHeader = () =>
    document.querySelector('header.m-header__mobile');

  const getDesktopHeader = () =>
    document.querySelector('header.m-header__desktop');

  const removeLegacyMobileWishlist = () => {
    document
      .querySelectorAll('.m-header__mobile-right .ks-mobile-header-wishlist')
      .forEach((node) => node.remove());
  };

  const mountSearchRow = () => {
    const mobileHeader = getMobileHeader();
    const wrapper = mobileHeader && mobileHeader.closest('.m-header__wrapper');
    if (!mobileHeader || !wrapper) return null;

    removeLegacyMobileWishlist();

    let row = wrapper.querySelector(':scope > .ks-mobile-search-row');
    if (!row) {
      row = document.createElement('div');
      row.className = 'ks-mobile-search-row';

      mobileHeader.classList.forEach((className) => {
        if (className === 'm-gradient' || className.startsWith('m-color-')) {
          row.classList.add(className);
        }
      });

      row.innerHTML = `
        <m-search-popup data-open-search-popup>
          <button
            class="ks-mobile-search-trigger"
            type="button"
            aria-label="Caută produse"
          >
            <span class="ks-mobile-search-trigger__icon">${searchIcon}</span>
            <span class="ks-mobile-search-trigger__text">
              Caută produse
            </span>
            <span class="ks-mobile-search-trigger__submit">${arrowIcon}</span>
          </button>
        </m-search-popup>`;

      mobileHeader.insertAdjacentElement('afterend', row);
    }

    return row;
  };

  const updateHeaderHeight = () => {
    resizeFrame = null;

    const mobileHeader = getMobileHeader();
    const desktopHeader = getDesktopHeader();
    const searchRow = document.querySelector('.ks-mobile-search-row');
    const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

    const height = isMobile
      ? (mobileHeader ? mobileHeader.offsetHeight : 0) +
        (searchRow ? searchRow.offsetHeight : 0)
      : desktopHeader
        ? desktopHeader.offsetHeight
        : 0;

    if (!height) return;

    document.documentElement.style.setProperty(
      '--m-header-height',
      `${height}px`
    );

    if (window.MinimogSettings) {
      window.MinimogSettings.headerHeight = height;
    }
  };

  const scheduleHeightUpdate = () => {
    if (resizeFrame) window.cancelAnimationFrame(resizeFrame);
    resizeFrame = window.requestAnimationFrame(updateHeaderHeight);
  };

  const observeHeader = () => {
    if (!('ResizeObserver' in window)) return;
    if (headerObserver) headerObserver.disconnect();

    headerObserver = new ResizeObserver(scheduleHeightUpdate);
    const mobileHeader = getMobileHeader();
    const desktopHeader = getDesktopHeader();
    const searchRow = document.querySelector('.ks-mobile-search-row');

    [mobileHeader, desktopHeader, searchRow].forEach((node) => {
      if (node) headerObserver.observe(node);
    });
  };

  const initialize = () => {
    mountSearchRow();
    observeHeader();
    scheduleHeightUpdate();

    window.setTimeout(scheduleHeightUpdate, 100);
    window.setTimeout(scheduleHeightUpdate, 500);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  window.addEventListener('resize', scheduleHeightUpdate, { passive: true });
  window.addEventListener('orientationchange', scheduleHeightUpdate);
  document.addEventListener('shopify:section:load', initialize);
  document.addEventListener('matchTablet', scheduleHeightUpdate);
  document.addEventListener('unmatchTablet', scheduleHeightUpdate);
})();
